import { FC, Ref } from 'react';

import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { ContractType } from '@telialt/models/src/EshopModel';
import { selectIsFullPricePayment, selectRentPlan } from '@telialt/utils/src/eshopSelectors';

import { PriceWithMonthlyPayment } from './PriceWithMonthlyPayment';
import { PriceWithoutMonthlyPayment } from './PriceWithoutMonthlyPayment';
import { PriceWithResidualAmount } from './PriceWithResidualAmount';

type Props = {
    ref: Ref<HTMLElement>;
};

export const TopPrice: FC<Props> = ({ ref }) => {
    const { cart } = useCartQuery();

    const isFullPricePayment = selectIsFullPricePayment(cart);
    const rentingPlanEntry = selectRentPlan(cart);

    if (cart.contractType === ContractType.Renting) {
        return <PriceWithResidualAmount rentingPlan={rentingPlanEntry} ref={ref} />;
    }
    if (isFullPricePayment) {
        return <PriceWithoutMonthlyPayment ref={ref} />;
    }

    return <PriceWithMonthlyPayment ref={ref} />;
};
